"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _all = require("animations-json/build/all");

var _LottieAnimationBase = _interopRequireDefault(require("../LottieAnimationBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Animation25 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(Animation25, _AnimationBase);

  var _super = _createSuper(Animation25);

  function Animation25(animObj) {
    var _this;

    _classCallCheck(this, Animation25);

    var animationId = animObj.animationId;
    var data = animObj.data;
    var config = {
      default: {
        colors: ['#000', '#FFF']
      },
      maxCharInline: 1000,
      minLines: 1,
      maxLines: 6,
      lineHeight: {
        base: 100,
        extra: 80
      },
      width: 660,
      height: 500,
      textShadow: false,
      inDuration: 1360,
      intermissionDuration: 3000,
      outDuration: 560,
      totalDuration: 4920
    };
    _this = _super.call(this, animObj, data, config);

    if (_this.browserName === 'Edge') {
      animationId = "".concat(animationId, "_Edge");
    }

    var animation = (0, _all.getAnimationJson)(animationId); // set colors
    // replace with color 1
    // black font replace with color 1

    var fonColorPattern1 = new RegExp('"fc":\\[0.353,0.353,0]', 'g'); // black shape replace with color 1

    var shapeColorPattern1 = new RegExp('"k":\\[0.352941176471,0.352941176471,0,1]', 'g'); // replace with color 2
    // white font replace with color 2

    var fontColorPattern2 = new RegExp('"fc":\\[0,1,0]', 'g'); // white shape replace with color 2

    var shapeColorPattern2 = new RegExp('"k":\\[0,1,0,1]', 'g');
    animation = animation.replace(fontColorPattern2, "\"fc\":[".concat(_this.colors[1], "]")).replace(shapeColorPattern2, "\"k\":[".concat(_this.colors[1], "]")).replace(fonColorPattern1, "\"fc\":[".concat(_this.colors[0], "]")).replace(shapeColorPattern1, "\"k\":[".concat(_this.colors[0], "]")); // replace place holders with the line value

    for (var i = 0; i < config.maxLines; i++) {
      var line = _this.lines.length > i ? _this.lines[i] : '';
      animation = animation.replace("{#DYNAMICINPUT_0".concat(i + 1, "#}"), line);
    } // parse string to object


    _this.json = JSON.parse(animation);
    return _this;
  }

  return Animation25;
}(_LottieAnimationBase.default);

exports.default = Animation25;